import React from 'react';
const useBodyLockScroll = skipBodyLock => {
  React.useLayoutEffect(() => {
    if (skipBodyLock) return;
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => document.body.style.overflow = originalStyle;
  }, [skipBodyLock]);
};
export default useBodyLockScroll;